import { UpdatePostTitleStore, updatePosttitleUseCase } from "./updatePostTitleUseCase";


const setPostTitleUseCase = (store: UpdatePostTitleStore, title: string) =>
    updatePosttitleUseCase(store, title);

export { setPostTitleUseCase }